<template>
  <div>
    <yd-popup
      v-model="guanzhuqrshow"
      position="center"
      width="90%"
      masker-opacity=".9"
    >
      <img
        class="qrimg"
        src="../assets/images/qrc.jpg"
      />
      <div class="ts">长按识别扫码关注公众号</div>
      <!-- <div
        class="guanbtn"
        @click="isSubscribe(1)"
      >我已关注</div> -->
    </yd-popup>
  </div>
</template>

<script>
export default {
  name: "Subscribe",
  data() {
    return {
      guanzhuqrshow: false
    };
  },
  mounted() {
    this.isSubscribe(0);
    var that = this;
    var inerval = setInterval(function() {
      if (that.guanzhuqrshow) {
        that.isSubscribe(1);
      } else {
        clearInterval(inerval);
      }
    }, 1000 * 5);
  },
  watch: {},
  methods: {
    isSubscribe(click) {
      this.$ajax({
        method: "post",
        url: "Ucenter/issubscribe",
        data: {}
      })
        .then(response => {
          // console.log(response);
          if (response.data.errno == 0) {
            //未关注
            if (click) {
              // this.$dialog.toast({
              //   mes: "休想骗我",
              //   timeout: 1500
              // });
            }
            this.guanzhuqrshow = true;
          } else {
            //已关注
            this.guanzhuqrshow = false;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped lang="css">
.qrimg {
  width: 100%;
  height: auto;
}
.ts {
  color: #fff;
  text-align: center;
  font-size: 0.6rem;
  padding-top: 10px;
  padding-bottom: 10px;
}
.guanbtn {
  margin-top: 10px;
  width: 3rem;
  background-color: #fff;
  border-radius: 5px;
  line-height: 1rem;
  text-align: center;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscribe.vue